import { FeatureToggles } from "@spartacus/core";

export const ebFeatureToggles: FeatureToggles = {
  a11yImproveContrast: false
};
